export default {"src":"/_next/static/media/Upload.81111361.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};